<template>
  <v-dialog v-model="show2" content-class="dialog-fixed-size dialog-small"
    @keydown.esc.stop="closeDialog"
    @keydown.enter.stop="step === (maxStep - 1) && validateAndSubmit()">
    <v-card>
      <v-card-title class="secondary--text">
        <h1 v-if="step === 2">
          {{ $t('LBL.PERMISSION') }}
        </h1>
        <h1 v-else-if="step === maxStep">
          {{ $t('LBL.DONE') }}
        </h1>
        <h1 v-else>
          {{ $t('LBL.MSG_YOUR_CHILD_S_DETAILS') }}
        </h1>
        <v-spacer></v-spacer>
        <v-icon dark x-large color="secondary">{{ stepTitleIcon }}</v-icon>
      </v-card-title>
      <v-card-text>
        <v-form ref="form1" v-show="step === 1">
          <div class="l-row">
            <v-text-field name="firstName" id="firstName" required
              :label="$t('LBL.MSG_YOUR_CHILD_S_FIRST_NAME')"
              v-model="firstName" :rules="firstNameRules"
            ></v-text-field>

            <v-text-field name="lastName" id="lastName" required
              :label="$t('LBL.MSG_YOUR_CHILD_S_FAMILY_NAME')"
              v-model="lastName" :rules="lastNameRules"
            ></v-text-field>
          </div>
        </v-form>

        <v-form ref="form2" v-show="step === 2">
          <v-checkbox
            class="checkbox-long-label"
            :label="$t('LBL.MSG_HAVE_PERMISSION_TO_CARRY_OUT_ASSESSMENT', {CHILD_FNAME: firstName})"
            v-model="hasPermOnBehalfOfChild"
            required
            :rules="hasPermOnBehalfOfChildRules"
          ></v-checkbox>

          <p v-html="$t('TXT.ADD_CHILD_DIALOG_PERMISSION_ACK_HTML')"></p>
        </v-form>
        <v-form ref="form3" v-show="step === 3">
          <div class="l-row">
            <label>{{ $t('LBL.MSGT_CHILD_S_DATE_OF_BIRTH', {CHILD_FNAME: firstName}) }}</label>
          </div>
          <div class="l-row">
            <v-menu
              ref="menu"
              lazy
              :close-on-content-click="false"
              v-model="birthdateMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-right="40"
              min-width="290px"
              :return-value.sync="birthdate"
            >
              <v-text-field
                slot="activator"
                label=""
                v-model="birthdate"
                readonly
                required
                :rules="birthdateRules"
                :hint="$t('LBL.MSGT_CHILD_AGE_HINT', {MTH_LOW: 0, MTH_HIGH: 30})"
              ></v-text-field>
              <v-date-picker
                ref="birthdatePicker"
                v-model="birthdate"
                :min="minBirthdate"
                :max="maxBdayDate"
                @change="$refs.menu.save(birthdate)"
                >
              </v-date-picker>
            </v-menu>
            <div class="input-group">
              <div class="input-group__messages input-group__hint">
                ({{ $t('LBL.MSGT_CHILD_AGE_HINT', {MTH_LOW: 0, MTH_HIGH: 30}) }})
              </div>
            </div>
          </div>
        </v-form>
        <v-form ref="form4" v-show="step === 4">
          <div class="l-row">
            <label>{{ $t('LBL.MSG_CONFIRM_DATE_OF_BIRTH') }}</label>
          </div>
          <div class="l-row">
            <p>{{ $t('LBL.MSGT_CONFIRM_CHILD_S_AGE_QUESTION', {CHILD_FNAME: firstName, AGE_MTHS: childAge}) }}</p>
          </div>
        </v-form>
        <v-form ref="form5" v-show="step === 5">
          <div class="l-row">
            <label>{{ $t('LBL.MSG_CHILD_S_DATE_OF_BIRTH') }}</label>
          </div>
          <div class="l-row">
            <p>{{ $t('LBL.MSGT_CHILD_BORN_PREMATURELY_QUESTION', {CHILD_FNAME: firstName}) }}</p>
          </div>
          <!-- <div class="l-row">
            <v-select
              :label="$t('Yes or No')"
              :placeholder="$t('MSG.LBL_CHOOSE_YOUR_OPTION')"
              :items="selectItemsYesOrNo"
              required
              v-model="isPremature"
              :rules="isPrematureRules">
            </v-select>
          </div> -->
        </v-form>
        <v-form ref="form6" v-show="step === 6">
          <p>{{ $t('LBL.MSG_HOW_MANY_WEEKS_BORN_EARLY_QUESTION', [firstName]) }}</p>
          <div class="l-row">
            <v-select
              :label="$t('MSG.LBL_SELECT_NUMBER_OF_WEEKS')"
              :placeholder="$t('MSG.LBL_SELECT_NUMBER_OF_WEEKS')"
              :items="selectItemsBirthWeeks"
              v-model="birthWeek"
              required
              :rules="birthWeekRules">
            </v-select>
          </div>
        </v-form>
        <v-form ref="form7" v-show="step === 7">
          <p v-html="$t('TXT.ADD_CHILD_DIALOG_LBL_CHILD_GENDER_HTML')"></p>
          <div class="l-row">
            <v-select
              :label="$t('LBL.SELECT')"
              :placeholder="$t('MSG.LBL_CHOOSE_YOUR_OPTION')"
              :items="selectItemsGender"
              v-model="gender"
              required
              :rules="genderRules">
            </v-select>
          </div>
        </v-form>
        <v-form ref="form8" v-show="step === 8">
          <p v-html="$t('TXT.ADD_CHILD_DIALOG_LBL_CHILD_HAS_AUTISM_SIBLINGS_HTML', {CHILD_FNAME: firstName})"></p>
          <div class="l-row">
            <v-select
              :label="$t('Select')"
              :placeholder="$t('MSG.LBL_CHOOSE_YOUR_OPTION')"
              :items="selectItemsYesOrNo"
              v-model="hasAutismSiblings"
              required
              :rules="hasAutismSiblingsRules">
            </v-select>
          </div>
        </v-form>
        <v-form ref="form9" v-show="step === 9">
          <v-checkbox
            class="checkbox-long-label"
            :label="$t('TXT.ADD_CHILD_DIALOG_LBL_AGREE_DATA_COLLECTION_HTML')"
            v-model="agreeDataCollection"
            required
            :rules="agreeDataCollectionRules"
          ></v-checkbox>
          <p v-html="$t('TXT.ADD_CHILD_DIALOG_VIEW_LTU_POLICY_HTML')"></p>
        </v-form>
        <div v-show="step === maxStep">
          <p v-html="$t('TXT.ADD_CHILD_DIALOG_FINISH_MESSAGE_HTML', {CHILD_FNAME: firstName, AGE_MTH: getAssessmentByAge(childAge)})"></p>
        </div>
      </v-card-text>
      <v-card-actions class="primary">
        <v-spacer></v-spacer>
        <v-btn flat dark v-show="step === 1" @click.stop="closeDialog">{{ $t('LBL.CANCEL') }}</v-btn> <!-- only show at first step -->
        <v-btn flat dark v-show="step > 1 && step < maxStep" @click.stop="prevStep" :disabled="loading">{{ lblStepBack }}</v-btn> <!-- not showing in first last step -->
        <v-btn flat dark v-show="step === 4" @click.stop="prevStep">{{ lblStepBackNo }}</v-btn>
        <v-btn flat dark v-show="step === 5" @click.stop="validateAndNextStep(false)">{{ lblStepNextNo }}</v-btn>
        <v-btn flat dark v-show="step < (maxStep - 1)" @click.stop="validateAndNextStep(true)">{{ lblStepNext }}</v-btn>
        <v-btn flat dark v-show="step === (maxStep - 1)" @click.stop="validateAndSubmit"
          :loading="loading" :disabled="loading">{{ lblStepNext }}</v-btn> <!-- only show at second last step (submitting step) -->
        <v-btn flat dark v-show="step === maxStep" @click.stop="closeDialog">{{ $t('LBL.FINISH') }}</v-btn> <!-- only show at last step -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapMutations } from 'vuex'
import AssessmentMixin from '@/components/mixins/AssessmentMixin'
import ServerErrorMixin from '@/components/mixins/ServerErrorMixin'
import { ENQUEUE_SNACKBAR } from '@/store/mutation-types'

export default {
  name: 'AddChildDialog',
  computed: {
    stepTitleIcon: function () {
      return [
        '',
        'face',
        'date_range',
        'date_range',
        'date_range',
        'date_range',
        'history',
        'face',
        'face',
        'face'
      ][this.step]
    },
    childAge: function () {
      let months = 0
      if (this.birthdate) {
        const todayDate = new Date()
        const birthdate = new Date()
        const dateParts = this.birthdate.split('-')
        birthdate.setFullYear(dateParts[0])
        birthdate.setMonth(dateParts[1] - 1)
        birthdate.setDate(dateParts[2])
        months = (todayDate.getFullYear() - birthdate.getFullYear()) * 12
        months -= birthdate.getMonth() + 1
        months += todayDate.getMonth()
        if (birthdate.getDate() < todayDate.getDate()) {
          months += 1
        }
      }
      return months <= 0 ? 0 : months
    },
    lblStepBack: function () {
      return this.$i18n.t('LBL.BACK')
    },
    lblStepBackNo: function () {
      return this.$i18n.t('LBL.NO')
    },
    lblStepNext: function () {
      return this.$i18n.t({4: 'LBL.YES', 5: 'LBL.YES'}[this.step] || 'LBL.NEXT')
    },
    lblStepNextNo: function () {
      return this.$i18n.t('LBL.NO')
    }
  },
  data () {
    const minBdayDate = new Date()
    minBdayDate.setMonth(minBdayDate.getMonth() - 31)
    minBdayDate.setDate(minBdayDate.getDate() + 1)
    const maxBdayDate = new Date()
    // maxBdayDate.setMonth(maxBdayDate.getMonth() - 11)
    // maxBdayDate.setDate(maxBdayDate.getDate() - 1)

    const selectItemsBirthWeeks = Array.from(Array(37).keys()).slice(22).reverse()

    return {
      show2: false,
      animating: false,
      loading: false,
      step: 1,
      maxStep: 10,
      firstNameRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.FIRST_NAME')})
      ],
      lastNameRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.FAMILY_NAME')})
      ],
      birthdateRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.BIRTHDATE')})
      ],
      isPrematureRules: [
        v => v !== null || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.MSG_THIS_FIELD')})
      ],
      birthWeekRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.MSG_THIS_FIELD')})
      ],
      genderRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.GENDER')})
      ],
      hasAutismSiblingsRules: [
        v => v !== null || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.MSG_THIS_FIELD')})
      ],
      hasPermOnBehalfOfChildRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.PERMISSION')})
      ],
      agreeDataCollectionRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.MSG_THIS_FIELD')})
      ],
      minBirthdate: minBdayDate.toISOString().substr(0, 10),
      maxBdayDate: maxBdayDate.toISOString().substr(0, 10),
      selectItemsYesOrNo: [
        {text: this.$i18n.t('LBL.YES'), value: true},
        {text: this.$i18n.t('LBL.NO'), value: false}
      ],
      selectItemsBirthWeeks,
      selectItemsGender: [
        {text: this.$i18n.t('LBL.MALE'), value: 'Male'},
        {text: this.$i18n.t('LBL.FEMALE'), value: 'Female'},
        {text: this.$i18n.t('MSG.PREFER_NOT_SAY'), value: 'Undisclosed'}
      ],
      birthdateMenu: false,
      firstName: '',
      lastName: '',
      birthdate: '',
      gender: '',
      isPremature: null,
      birthWeek: 0,
      hasPermOnBehalfOfChild: false,
      hasAutismSiblings: null,
      agreeDataCollection: false
    }
  },
  methods: {
    updateStep (nextStep) {
      this.animating = true
      this.show2 = false
      setTimeout(() => {
        this.step = nextStep
        Vue.nextTick(() => {
          this.animating = false
          this.show2 = true
        })
      }, 100)
    },
    validateAndNextStep (userChoice) {
      const form = this.$refs[`form${this.step}`]
      if (form.validate()) {
        let incStep = 1
        if (this.step === 5) {
          if (userChoice === false) {
            incStep = 2
            this.isPremature = false
            this.birthWeek = 0
          } else {
            this.isPremature = true
          }
        }
        this.updateStep(this.step + incStep)
      }
    },
    prevStep () {
      let decStep = 1
      if (this.step === 7 && !this.isPremature) {
        decStep = 2
      }
      this.updateStep(this.step - decStep)
    },
    validateAndSubmit () {
      if (this.$refs[`form${this.step}`].validate()) {
        const data = {
          firstName: this.firstName,
          lastName: this.lastName,
          birthDate: this.birthdate,
          gender: this.gender,
          birthWeek: this.birthWeek,
          hasAutismSiblings: this.hasAutismSiblings,
          permitToCarryAss: this.hasPermOnBehalfOfChild,
          acceptedAnonDataRes: this.agreeDataCollection
        }

        console.log('validateAndSubmit', data)

        if (this.loading) {
          return
        }

        this.loading = true

        this.doCreate(data)
          .then(() => {
            // this.showMessage({
            //   text: this.$i18n.t('MSG.ADD_CHILD_SUCCESS'),
            //   color: 'success'
            // })
            // this.closeDialog()
            this.updateStep(this.step + 1)
          })
          .catch((error) => {
            console.log('api error', error)
            this.showMessage({
              text: this.$i18n.t(this.getErrorMessage(error) || 'MSG.SYSTEM_ERROR_RETRY'),
              color: 'error'
            })
          })
          .finally(() => { this.loading = false })
      }
    },
    closeDialog () {
      this.show2 = false
    },
    ...mapActions({
      doCreate: 'addChild'
    }),
    ...mapMutations({
      showMessage: ENQUEUE_SNACKBAR
    })
  },
  mixins: [
    AssessmentMixin,
    ServerErrorMixin
  ],
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show (val) {
      this.show2 = val
    },
    show2 (val) {
      if (this.show2 !== this.show) {
        this.$emit('update:show', this.show2)
      }

      if (!val && !this.animating) {
        Vue.nextTick(() => {
          for (let i = this.step; i <= this.maxStep; i++) {
            this.$refs[`form${i}`] && this.$refs[`form${i}`].reset()
          }

          this.step = 1
        })
      }
    },
    birthdateMenu (val) {
      val && this.$nextTick(() => (this.$refs.birthdatePicker.activePicker = 'YEAR'))
    }
  }
}
</script>

<style lang="scss" scoped>
.card__title {
  h1 {
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialogs/AddChildDialog.vue